export interface ILandingPageCustomItem {
  title: string;
  imageUrl: string;
  subtitle?: string;
  description?: string;
}

export interface ILandingPageExperienceItem {
  title: string;
  description: string;
  imageUrl: string;
  iconKey: string;
}

export interface ILandingPageTestimonialItem {
  name: string;
  location: string;
  quote: string;
  avatarUrl?: string;
  rating: number;
}

export enum LayoutType {
  ImmersiveGallery = 'immersive-gallery',
  StoryDriven = 'story-driven',
  FeatureShowcase = 'feature-showcase',
}

export interface ILandingPageRenderProduct {
  type: string;
  nights: number;
  name: string;
  price: number;
}

export interface ILandingPageCruiseLine {
  id?: string;
  cruiseLineId?: number;
  name: string;
  logoUrl?: string;
  videoUrl?: string;
  videoEmbedUrl?: string;
}

/** JSON from GET /certificates/api/v1/public/landing-pages/by-template/{templateId} */
export interface ILandingPageRenderData {
  id: string;
  slug: string;
  layoutType: LayoutType;
  customHeadline?: string;
  customSubheadline?: string;
  customCtaText?: string;
  customCtaUrl: string;
  customDescription?: string;
  trackingPixelHtml?: string;
  customItems?: ILandingPageCustomItem[];
  experienceItems?: ILandingPageExperienceItem[];
  isActive: boolean;
  showFakeTestimonials?: boolean;
  testimonialItems?: ILandingPageTestimonialItem[];
  templateId: string;
  templateName: string;
  templateDescription?: string;
  templateImageUrl?: string;
  validityMonths: number;
  totalPrice: number;
  averageRetailPrice: number;
  savings: number;
  products: ILandingPageRenderProduct[];
  eligibleCruiseLines?: ILandingPageCruiseLine[];
}
